"use strict";
/**
 * Wire vocabulary for the backend `UserEvent` table (`POST /events`).
 *
 * These literals MIRROR the Prisma enums in `cred-backend-1.0`
 * (`prisma/schema.prisma` → `EventPlatform`, `EventType`). They are duplicated
 * rather than generated because this package is bundled by Next.js AND by
 * mobile's Metro build, neither of which can reach the backend's Prisma client.
 * If the backend enums change, change these in the same PR.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUserEventUserId = exports.isUserEventTypeAvailable = exports.USER_EVENT_TYPES = exports.PENDING_USER_EVENT_TYPES = exports.LIVE_USER_EVENT_TYPES = exports.EVENT_PLATFORMS = void 0;
exports.EVENT_PLATFORMS = [
    'WEBSITE',
    'BROWSER_EXTENSION',
    'MOBILE_APP',
];
/**
 * Event types the BACKEND currently accepts.
 *
 * `SHARE_SKIM` moved here from `PENDING_USER_EVENT_TYPES` once the backend
 * migration adding it to the Prisma `EventType` enum deployed
 * (cred-backend-1.0 `4b42b49`).
 */
exports.LIVE_USER_EVENT_TYPES = [
    'SIGN_UP',
    'SIGN_IN',
    'SHARE_SKIM',
];
/**
 * Event types this client can construct but the backend cannot yet store.
 *
 * Empty today. The mechanism is kept because it is how a new event type ships
 * safely: the clients can be wired and merged ahead of the backend migration,
 * with `isUserEventTypeAvailable` short-circuiting the emit so an unknown enum
 * value never reaches `@IsEnum` and 400s on every action. When the migration
 * deploys, move the literal into `LIVE_USER_EVENT_TYPES` — that one-line move
 * is the whole rollout step.
 */
exports.PENDING_USER_EVENT_TYPES = [];
exports.USER_EVENT_TYPES = [
    ...exports.LIVE_USER_EVENT_TYPES,
    ...exports.PENDING_USER_EVENT_TYPES,
];
/**
 * True when the backend can actually store this event type today.
 *
 * Callers MUST gate on this before posting. Returning false is not an error
 * condition — it means "correctly wired, waiting on the backend enum", and the
 * caller should silently skip the write.
 */
const isUserEventTypeAvailable = (eventType) => exports.LIVE_USER_EVENT_TYPES.includes(eventType);
exports.isUserEventTypeAvailable = isUserEventTypeAvailable;
/**
 * Coerce a client-held user id (always a string in our session types) to the
 * positive integer the backend requires. Returns null when the value is absent,
 * non-numeric, fractional, zero/negative, or not finite — the caller must then
 * skip the event rather than post a payload that will 400.
 */
const toUserEventUserId = (rawId) => {
    if (rawId === null || rawId === undefined || rawId === '')
        return null;
    const parsed = typeof rawId === 'number' ? rawId : Number(rawId);
    if (!Number.isFinite(parsed))
        return null;
    if (!Number.isInteger(parsed))
        return null;
    if (parsed < 1)
        return null;
    return parsed;
};
exports.toUserEventUserId = toUserEventUserId;
